{
  "title": "Classes",
  "description": "Groups of pupils with their teachers.",
  "searchPlaceholder": "Search classes…",
  "filter": {
    "label": "Show",
    "active": "Active",
    "archived": "Archived",
    "all": "All",
    "yearLabel": "Academic year",
    "currentYear": "Current year ({{name}})",
    "currentYearPlain": "Current year",
    "allYears": "All years"
  },
  "table": {
    "name": "Name",
    "teachers": "Teachers",
    "pupils": "Pupils",
    "status": "Status"
  },
  "status": {
    "active": "Active",
    "archived": "Archived"
  },
  "noTeachers": "No teachers yet",
  "teachers": {
    "manage": "Manage",
    "title": "Class teachers",
    "description": "Choose the staff members who teach this class.",
    "noStaff": "No active staff members yet — invite some first.",
    "save": "Save teachers",
    "success": "Teachers updated"
  },
  "lessonsLink": "Lessons",
  "empty": {
    "title": "No classes yet",
    "manageText": "Create your first class to start enrolling pupils.",
    "pupilText": "You are not enrolled in any class yet.",
    "filterText": "Nothing matches the current filters."
  },
  "create": {
    "button": "Create class",
    "title": "Create a class",
    "description": "Name the class — you can enroll pupils right after.",
    "name": "Class name",
    "namePlaceholder": "6-A Computer Science (gr2)",
    "nameHint": "Cohort → subject → subgroup: “6-A Computer Science (gr2)”. No subgroups — just “6-A Computer Science”. The same order keeps one cohort’s classes together in the list.",
    "descriptionLabel": "Description",
    "descriptionPlaceholder": "Optional — what this class is about",
    "submit": "Create class",
    "submitting": "Creating…",
    "success": "Class created",
    "failed": "Could not create the class",
    "yearLabel": "Academic year",
    "yearPlaceholder": "Choose a year",
    "yearCurrent": "current"
  },
  "edit": {
    "button": "Edit class",
    "title": "Edit class",
    "description": "Rename the class or change what it is about.",
    "submit": "Save changes",
    "submitting": "Saving…",
    "success": "Class updated",
    "failed": "Could not save the class"
  },
  "validation": {
    "nameRequired": "Class name is required",
    "codeRequired": "Enter the join code",
    "pupilRequired": "Choose a pupil"
  },
  "detail": {
    "back": "Back to classes",
    "teachers": "Teachers",
    "roster": "Roster",
    "rosterCount_one": "{{count}} pupil enrolled",
    "rosterCount_other": "{{count}} pupils enrolled",
    "noDescription": "No description",
    "archivedNotice": "This class is archived — activity has stopped, but its data stays readable."
  },
  "roster": {
    "empty": "No pupils enrolled yet.",
    "enroll": "Enroll pupil",
    "enrollTitle": "Enroll a pupil",
    "enrollDescription": "Pick a pupil of this school to add to the class.",
    "pupil": "Pupil",
    "pupilPlaceholder": "Choose a pupil",
    "noPupils": "No pupils available to enroll — invite them first.",
    "enrollSubmit": "Enroll",
    "enrollSuccess": "Pupil enrolled",
    "unenroll": "Unenroll",
    "unenrollTitle": "Unenroll {{name}}?",
    "unenrollDescription": "They will leave this class, but their grades and history are kept.",
    "unenrollSuccess": "Pupil unenrolled",
    "table": {
      "name": "Name",
      "email": "Email",
      "status": "Status"
    },
    "active": "Active",
    "inactive": "Inactive"
  },
  "joinCode": {
    "title": "Join code",
    "description": "Pupils enter this code (or open the link) to join the class on their own.",
    "reveal": "Show join code",
    "revealing": "Loading the code…",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "copyCode": "Copy code",
    "copyLink": "Copy join link",
    "copiedCode": "Code copied",
    "copiedLink": "Join link copied",
    "copyFailed": "Could not copy — please copy it manually",
    "rotate": "Rotate",
    "rotateTitle": "Rotate the join code?",
    "rotateDescription": "The current code and link stop working immediately.",
    "rotated": "Join code rotated",
    "enable": "Enable",
    "disable": "Disable",
    "enabledToast": "Join code enabled",
    "disabledToast": "Join code disabled"
  },
  "archive": {
    "button": "Archive class",
    "title": "Archive {{name}}?",
    "description": "Activity stops, but all data stays readable. You can reopen the class later.",
    "success": "Class archived"
  },
  "unarchive": {
    "button": "Reopen class",
    "success": "Class reopened"
  },
  "join": {
    "title": "Join a class",
    "description": "Enter the code your teacher shared with you.",
    "codeLabel": "Join code",
    "codePlaceholder": "e.g. ABCD2345",
    "submit": "Join class",
    "submitting": "Joining…",
    "success": "Welcome to {{name}}!",
    "failed": "Could not join the class",
    "backToDashboard": "Back to dashboard"
  },
  "promote": {
    "button": "Promote to next year",
    "title": "Promote {{name}}",
    "description": "Creates the class in another year: teachers carry over, the roster only if you choose, the join code never. Grades and history stay with this class.",
    "yearLabel": "Target year",
    "yearPlaceholder": "Choose a year",
    "noYears": "No other academic years — add the next year in Settings first.",
    "nameLabel": "New class name",
    "carryRoster": "Carry the roster",
    "carryRosterNote": "Re-enrolls every actively enrolled pupil into the new class.",
    "archiveSource": "Archive this class",
    "archiveSourceNote": "Ends activity here; everything stays readable.",
    "validation": "Choose the target year first",
    "success": "{{name}} created",
    "submit": "Promote"
  }
}
